import React, { createContext, useContext, useMemo } from 'react';

/** @import * as CTypes from '$types/components/contexts/article-listing.d.ts' */

/**
 * @type {React.Context<CTypes.ArticleListingContextData>}
 */
// @ts-expect-error
const ArticleListingContext = createContext(null);

/* ========================================================================= */
/* Hook(s) */
/* ========================================================================= */

const useArticleListing = () => {
    const context = useContext(ArticleListingContext);

    if (context === undefined) {
        throw new Error('useLocale must be used within a LocaleProvider.');
    }

    return context;
};

/* ========================================================================= */
/* Provider(s) */
/* ========================================================================= */

/**
 * @type {CTypes.ArticleListingContextProvider}
 */
const ArticleListingProvider = ({
    children,
    conceptId,
    listing
}) => {
    return (
        <ArticleListingContext.Provider value={useMemo(() => ({
            conceptId,
            listing
        }), [
            conceptId,
            listing
        ])}>
            {children}
        </ArticleListingContext.Provider>
    );
};


/* ========================================================================= */
/* Export(s) */
/* ========================================================================= */

export {
    ArticleListingProvider,
    useArticleListing
};
